<template>
  <div>
    <template v-show="isCallingApi">
      <md-progress-bar :style="getStyle" v-if="type==='bar'" md-mode="indeterminate"/>
      <md-progress-spinner v-else :style="getStyle" md-mode="indeterminate" :md-diameter="25" :md-stroke="2"/>
    </template>
    
    <md-content v-if="hasApiError" class="md-accent">
      <div v-if="apiError.errorType">{{apiError.errorType}}</div>
      <div v-if="apiError.errorMessage">{{apiError.errorMessage}}</div>
      <div v-if="apiError.debugCode">Api Error({{apiError.debugCode}})</div>
      <div class="md-accent" v-for="msg in apiError.messages">{{msg}}</div>
    </md-content>
    <slot v-if="!isCallingApi"/>

  </div>
</template>
<script>
  export default {
    name: 'calling-api',
    props: {
      path: String,
      paths: Array,
      type: String,
      once: Boolean,
      notDisplayError: Boolean,
    },
    data: () => ({ called: false }),
    watch: {
      isCallingApi(newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.called = true;
        }
      }
    },
    computed: {
      isCallingApi() {
        if (this.once && this.called) {
          return false;
        }
        const find = _(this.$store.state.callingApis).filter(it => it.calling > 0).find(it => it.apiPath === this.path || (this.paths && _(this.paths).contains(it.apiPath)));
        return !!find;
      },
      hasApiError() {
        return !!this.apiError && !this.notDisplayError;
      },
      apiError() {
        const find = _(this.$store.state.apiErrorResponses).filter(it=>!!it.errorRes).find(it => it.apiPath === this.path || (this.paths && _(this.paths).contains(it.apiPath)));
        if (find) {
          return find.errorRes;
        }
        return find;
      },
      getDiameter() {
        if (this.isCallingApi) {
          return 50;
        }
        return 0;
      },
      getStyle() {
        if (!this.isCallingApi) {
          return {
            display: 'none',
          };
        }
        return {};
      }
    }
  }
</script>
